<div id="bdc-accueil" fxFlex="100">
  <div class="center">

    <div class="header" fxLayout="row" fxLayoutAlign="start center">

      <div class="search-wrapper" fxFlex fxLayout="row" fxLayoutAlign="start center">

        <div class="search" fxLayout="row" fxLayoutAlign="start center">
          <mat-icon class="secondary-text" color="primary">search</mat-icon>
          <input [matAutocomplete]="autoArt" type="text" matInput name="searchText" id="SearchBox"
                 placeholder="Je cherche ..."
                 [formControl]="term" fxFlex>

          <mat-autocomplete #autoArt="matAutocomplete" [displayWith]="displayPageFn.bind(this)">
            <mat-option *ngFor="let model of pageSearch | async"
                        matTooltip="{{model.title}}"
                        [value]="model"
                        (onSelectionChange)="goPage(model)">
              {{ model.title }}
            </mat-option>
          </mat-autocomplete>

        </div>

      </div>

    </div>
  </div>
</div>
